import { render, staticRenderFns } from "./ModalNovidade.vue?vue&type=template&id=28a427f7&scoped=true"
import script from "./ModalNovidade.vue?vue&type=script&lang=js"
export * from "./ModalNovidade.vue?vue&type=script&lang=js"
import style0 from "./ModalNovidade.vue?vue&type=style&index=0&id=28a427f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a427f7",
  null
  
)

export default component.exports